export default "__VITE_ASSET__aad1941e__"